<template>
    <div>
        <app-header />
        <router-view />
    </div>
</template>

<script>

import Header from './components/Header.vue'

export default {
  name: 'App',
  data() {
    return {
      state: this.$root.$data.state
    }
  },
  components: {
    'app-header': Header,
  },
}

</script>